import { ChainId, Percent } from '@uniswap/sdk-core'
import { useSwapAndLimitContext, useSwapContext } from 'state/swap/hooks'
import styled from 'styled-components'
// import { isIFramed } from 'utils/isIFramed'

import { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { FeatureFlags } from 'uniswap/src/features/experiments/flags'
import { useFeatureFlag } from 'uniswap/src/features/experiments/hooks'
import { RowBetween } from '../Row'
// import SwapBuyFiatButton from './SwapBuyFiatButton'
import logo from 'assets/images/logo.png'
import settings from 'assets/svg/settings.svg'
import { isUniswapXTrade } from 'state/routing/utils'
import { useUserSlippageTolerance } from 'state/user/hooks'
import { SlippageTolerance } from 'state/user/types'
import { TextParagraph } from 'theme/components/text'
import { useFormatter } from 'utils/formatNumbers'
import { ModalSlippage } from './ModalSlippage'
import { SwapTab } from './constants'

const StyledSwapHeader = styled(RowBetween)`
  margin-bottom: 12px;
  padding-right: 4px;
  color: ${({ theme }) => theme.neutral2};
`

// const HeaderButtonContainer = styled(RowFixed)<{ compact: boolean }>`
//   gap: ${({ compact }) => (compact ? 0 : 16)}px;

//   ${SwapHeaderTabButton} {
//     ${({ compact }) => compact && 'padding: 8px 12px;'}
//   }
// `

const PathnameToTab: { [key: string]: SwapTab } = {
  '/swap': SwapTab.Swap,
  '/send': SwapTab.Send,
  '/limit': SwapTab.Limit,
}

export default function SwapHeader({ compact, syncTabToUrl }: { compact: boolean; syncTabToUrl: boolean }) {
  const limitsEnabled = useFeatureFlag(FeatureFlags.LimitsEnabled)
  // const sendEnabled = useFeatureFlag(FeatureFlags.SendEnabled) && !isIFramed()
  const { chainId, currentTab, setCurrentTab } = useSwapAndLimitContext()
  const {
    derivedSwapInfo: { trade, autoSlippage },
  } = useSwapContext()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (PathnameToTab[pathname] === SwapTab.Limit && (!limitsEnabled || chainId !== ChainId.MAINNET)) {
      navigate(`/${SwapTab.Swap}`, { replace: true })
      return
    }

    setCurrentTab(PathnameToTab[pathname] ?? SwapTab.Swap)
  }, [chainId, limitsEnabled, navigate, pathname, setCurrentTab])

  // Limits is only available on mainnet for now
  if (chainId !== ChainId.MAINNET && currentTab === SwapTab.Limit) {
    setCurrentTab(SwapTab.Swap)
  }

  // const onTab = useCallback(
  //   (tab: SwapTab) => {
  //     sendAnalyticsEvent('Swap Tab Clicked', { tab })
  //     if (syncTabToUrl) {
  //       navigate(`/${tab}`, { replace: true })
  //     } else {
  //       setCurrentTab(tab)
  //     }
  //   },
  //   [navigate, setCurrentTab, syncTabToUrl]
  // )

  const [isVisible, setIsVisible] = useState(false)
  const { formatPercent } = useFormatter()
  const [userSlippageTolerance] = useUserSlippageTolerance()

  const percentage = useMemo(() => {
    if (userSlippageTolerance === SlippageTolerance.Auto || isUniswapXTrade(trade)) {
      return '0.5%' // Default slippage for UniswapX trades
      // return SlippageTolerance.Auto
    }

    return `${formatPercent(userSlippageTolerance as Percent)}`
  }, [formatPercent, trade, userSlippageTolerance])

  return (
    <StyledSwapHeader>
      {/* <HeaderButtonContainer compact={compact}> */}
      {/* <SwapHeaderTabButton
          as={pathname === '/swap' ? 'h1' : 'button'}
          role="button"
          tabIndex={0}
          $isActive={currentTab === SwapTab.Swap}
          onClick={() => {
            onTab(SwapTab.Swap)
          }}
        >
          <Trans>Swap</Trans>
        </SwapHeaderTabButton> */}
      {/*{limitsEnabled && chainId === ChainId.MAINNET && (*/}
      {/*  <SwapHeaderTabButton*/}
      {/*    $isActive={currentTab === SwapTab.Limit}*/}
      {/*    onClick={() => {*/}
      {/*      onTab(SwapTab.Limit)*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    <Trans>Limit</Trans>*/}
      {/*  </SwapHeaderTabButton>*/}
      {/*)}*/}
      {/*{sendEnabled && (*/}
      {/*  <SwapHeaderTabButton*/}
      {/*    $isActive={currentTab === SwapTab.Send}*/}
      {/*    onClick={() => {*/}
      {/*      onTab(SwapTab.Send)*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    <Trans>Send</Trans>*/}
      {/*  </SwapHeaderTabButton>*/}
      {/*)}*/}
      {/*<SwapBuyFiatButton />*/}
      {/* </HeaderButtonContainer> */}

      <div className="flex items-center gap-[6px]">
        <div className="w-[18px] h-[18px]">
          <img src={logo} alt="logo" width={128} height={128} loading="lazy" />
        </div>

        <TextParagraph size="xs" className="font-medium" variant="black">
          WorldSwap
        </TextParagraph>

        <p className="text-[13px] leading-[18px] text-light7">/</p>

        <p className="text-[13px] leading-[18px] text-light7">slippage</p>

        <p className="text-[13px] leading-[18px] text-black underline-wavy-red">{percentage}</p>
      </div>

      <button
        onClick={() => setIsVisible((v) => !v)}
        className="w-6 h-6 flex items-center justify-center hover:bg-light3 rounded-full transition-all"
      >
        <img src={settings} alt="settings" width={24} height={24} loading="lazy" />
      </button>

      {/* {currentTab === SwapTab.Swap && (
        <RowFixed>
          <SettingsTab autoSlippage={autoSlippage} chainId={chainId} compact={compact} trade={trade.trade} />
        </RowFixed>
      )} */}

      {isVisible && <ModalSlippage isVisible={isVisible} setIsVisible={setIsVisible} />}
    </StyledSwapHeader>
  )
}
